import { FC, useState } from "react";
import { FlyoutContextOutgoingProps, withFlyoutContext } from "../../../shared/Flyouts";
import { UserContextProps, withUserContext } from "../../../user";
import { TerminateProps, WrappedTerminateProvidersPanel, getDefaultIdentifier } from "../TerminateProvidersPanel";
import { ProviderNetworkType } from "../../enumerators";
import { SimulateProviderTermination } from "./SimulateProviderTermination";

type TerminateProvidersSimulationPanelProps = TerminateProps & UserContextProps & FlyoutContextOutgoingProps &
{
  providerNetworkType: ProviderNetworkType,
  regionSetId: number
};

const TerminateProvidersSimulationPanel: FC<React.PropsWithChildren<TerminateProvidersSimulationPanelProps>> = (props: TerminateProvidersSimulationPanelProps) => {
  const [allSpecialties, setAllSpecialties] = useState<boolean>(false);
  const [allLocations, setAllLocations] = useState<boolean>(false);
  const [identifier, setIdentifier] = useState<string>(getDefaultIdentifier(props.selectedProviders, null, null));

  return <div>
    <SimulateProviderTermination
      {...props}
      selectedProviders={props.selectedProviders}
      specialtyGroupCode={props.specialtyGroupCode}
      identifier={identifier}
      allLocations={allLocations}
      allSpecialties={allSpecialties}
    />
    <WrappedTerminateProvidersPanel
      onSubmit={props.onSubmit}
      projectId={props.projectId}
      selectedProviders={props.selectedProviders}
      specialtyGroupCode={props.specialtyGroupCode}
      terminatePanelMode={props.terminatePanelMode}
      setAllSpecialtiesInParent={setAllSpecialties}
      setAllLocationsInParent={setAllLocations}
      setIdentifierInParent={setIdentifier}
    />
  </div>;
};

const WrappedTerminateProvidersSimulationPanel = withFlyoutContext(withUserContext(TerminateProvidersSimulationPanel));

export { WrappedTerminateProvidersSimulationPanel };
